import { InsertRowAboveOutlined } from "@ant-design/icons"
import { Button, Flex, Typography } from "antd"
import React, { useCallback } from "react"

import { ImportButton } from "../../../../components/ImportButton.tsx"
import { SearchBar } from "../../../../components/Input/SearchBar.tsx"
import { type PermissionProjectPermissions } from "../../../SettingsPermissions/types/permissions.types.ts"
import { ProjectsLeadApprovalTrigger } from "../../ProjectsLeadApproval/ProjectsLeadApprovalTrigger.tsx"
import { useProjectsViewSwitch } from "../../helpers/projects-view-preference.ts"
import type { ProjectFilters } from "../../redux/projects.types.ts"

const { Title, Text } = Typography

interface ProjectListTableHeaderProps {
  projectPermissions: PermissionProjectPermissions
  search: string | null
  onFilersChange: (data: Partial<ProjectFilters>) => void
  onRefetchProjectsCallback: () => void
  onImport: (file: File) => Promise<void>
  onDownloadTemplate: () => Promise<void>
}

export function ProjectListTableHeader({
  projectPermissions,
  search,
  onFilersChange,
  onRefetchProjectsCallback,
  onImport,
  onDownloadTemplate
}: ProjectListTableHeaderProps) {
  const switchProjectsView = useProjectsViewSwitch()

  const onSearchHandler = useCallback(
    (q: string | null) => onFilersChange({ q }),
    [onFilersChange]
  )

  return (
    <Flex justify={"space-between"} align={"center"}>
      <Flex vertical>
        <Title className={"text-start"} level={2}>
          Projects
        </Title>
        <Text type={"secondary"}>
          Manage and track all your projects in one place.
        </Text>
      </Flex>

      <Flex gap={8}>
        <SearchBar
          placeholder="Search projects..."
          defaultValue={search || ""}
          onSearch={onSearchHandler}
        />

        {projectPermissions?.projects?.project_create && (
          <ImportButton
            onImport={onImport}
            onDownloadTemplate={onDownloadTemplate}
          />
        )}

        {projectPermissions?.projects?.project_create && (
          <ProjectsLeadApprovalTrigger
            onRefetchCallback={onRefetchProjectsCallback}
          />
        )}

        <Button
          type={"primary"}
          onClick={() => switchProjectsView("grid")}
          icon={<InsertRowAboveOutlined />}
        >
          View Grid
        </Button>
      </Flex>
    </Flex>
  )
}
